import { useState } from "react";
// import { NavLink } from "react-router-dom";
import { Link, animateScroll as scroll } from "react-scroll";
import Logo from "../../../assets/images/pro_bill_logo.svg";
import { SearchEye, DropDown, HamburgerIcon } from "../../../icons";
import RegisterPopUp from "../../UI/registerPopup";
import Wrapper from "../../UI/wrapper";
import styles from "./index.module.css";
import BurgerMenu from "./components";
function TheHeader() {
  const [register, setRegister] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false); // 🆕
  return (
    <>
      <header className={styles["header"]}>
        {register ? <RegisterPopUp setRegister={setRegister} /> : null}

        <div className={styles["container"]}>
          <nav className={styles["bar"]}>
            <a href="#">
              <img className={styles["logo"]} src={Logo} alt="Probill" />
            </a>
            <ul className={styles["list"]}>
              <li>
                <a href="#tutorial" smooth={true}>
                  Probill nədir?
                </a>
              </li>
              <li>
                <a href="#customers" smooth={true}>
                  Müştərilərimiz
                </a>
              </li>
              <li>
                <a href="#products" smooth={true}>
                  Məhsullar
                </a>
              </li>

              {/* <li>
            <div className={styles["dropdown1"]}>
              Məhsullar{" "}
              <div className={styles["arrow"]}>
                <DropDown />
              </div>
              <ul className={styles["dropdown-menu1"]}>
                <li>
                  <Link to="products" smooth={true}>
                    Probill yaşayış kompleksi
                  </Link>
                </li>
                <li>
                  <Link to="products" smooth={true}>
                    Təhsil billinqi
                  </Link>
                </li>
                <li>
                  <Link to="products" smooth={true}>
                    Plaza idarəetmə
                  </Link>
                </li>
                {/* <li>
                  <Link to="products" smooth={true}>
                    Probill qeyri-yaşayış...
                  </Link>
                </li> */}
              {/* <li>
                  <Link to="products" smooth={true}>
                    Parkinq servis billinq...
                  </Link>
                </li>
                <li>
                  <Link to="products" smooth={true}>
                    Lift servis billinq
                  </Link>
                </li>
                <li>
                  <Link to="products" smooth={true}>
                    Damafon servis billing...
                  </Link>
                </li>
              </ul>
            </div>
          </li>  */}
              <li>
                <a href="#forWho" smooth={true}>
                  Kimlər üçündür?
                </a>
              </li>

              <li>
                <a href="#solutions" smooth={true}>
                  Həllər
                </a>
              </li>
              {/* <li>
            <Link>Qiymət</Link>
          </li> */}
              <li>
                <a href="#contact" smooth={true}>
                  Əlaqə
                </a>
              </li>
            </ul>
            <div className={styles["buttons"]}>
              <div className={styles["search"]}>
                <SearchEye />
              </div>
              <div className={styles["right"]}>
                {/* <button className={styles["login"]}>
              Daxil ol
            </button> */}
                <button className={styles["demo"]} onClick={() => setRegister(true)}>
                  Demo
                </button>
                <div className={styles["dropdown"]}>
                  AZE
                  <ul className={styles["dropdown-menu"]}>
                    <li>AZE</li>
                    <li>ENG</li>
                    <li>RUS</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className={styles["hamburger"]} onClick={() => setMenuOpen(true)}>
              <HamburgerIcon />
            </div>
          </nav>
        </div>
      </header>

      <BurgerMenu isOpen={menuOpen} setIsOpen={setMenuOpen} setRegister={setRegister} />
    </>
  );
}
export default TheHeader;
